<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText"
      class="side-menu__filter"
      size="small"
      clearable
      suffix-icon="el-icon-search"
      @clear="handleSearch(filterText)"
      @keydown.enter.native="handleSearch(filterText)"
      @change="handleSearch(filterText)"
    ></el-input>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="true"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in list"
          :key="route.id"
          :item="route"
          :base-path="route.router_url"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import { getRoleMenu } from "@/api/index";
import store from "@/store";
import router from "@/router";
export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      list: [],
      menuList: [],
      filterText: "",
      dialogVisible: false,
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    handleSearch(event) {
      console.log(event);
      // 将将输入的字符串中的小写字母转为大写字母
      event = event.toUpperCase();
      let newMenuList = [];
      // 将父组件传过来的导航栏数据进行深拷贝一层
      const copySideMenuList = JSON.parse(JSON.stringify(this.menuList));
      console.log(copySideMenuList, "ffww");
      copySideMenuList.forEach((firstItem) => {
        // 循环判断导航栏数据是否匹配到搜索的字符
        if (firstItem.title.includes(event)) {
          newMenuList.push(firstItem);
        }
        if (!firstItem.title.includes(event) && firstItem.children) {
          for (let secondItem of firstItem.children) {
            if (secondItem.title.includes(event)) {
              newMenuList.push(secondItem);
            }
          }
        }
      });
      if (newMenuList.length > 0) {
        console.log(newMenuList);
        this.list = newMenuList;
      } else {
        this.$message.warning("未匹配到该菜单");
      }
      // 搜索字符串为空时返回原数据
      if (event == "") {
        this.list = this.menuList;
      }
    },

    async fetchData() {
      var that = this;
      var date = {
        id: localStorage.getItem("userId"),
        auth_type: 2,
        is_tree: 2,
      };
      this.menuList = [];
      getRoleMenu(date).then((response) => {
        if (response.data.lists.length == 0) {
          this.$router.push({ path: "/404" });
          this.$alert("该账号暂无权限，请联系管理员添加", "提示", {
            confirmButtonText: "确定",
            customClass: "messageIndex",
            showClose: false,
            callback: (action) => {
              window.localStorage.clear();
              // 状态保持清除后刷新页面
              window.location.reload();
              this.$router.push(`/login`);
            },
          });
        } else {
          this.menuList = response.data.lists;
          this.list = response.data.lists;
        }

        // if (this.list.length == 0) {
        // } else {
        //   // this.$router.push(`/404`)
        //   const route = this.$route;
        //   const { meta, path } = route;
        //   this.menuList =  this.pushList(this.menuList, this.list);
        //   if(path == '/dashboard' && !this.menuList.includes('/dashboard')){
        //     this.$router.push(this.menuList[0])
        //   }else{
        //   }
        // }
        // this.activeMenu('/conf/note')
      });
    },
    pushList(list, arr) {
      arr.forEach((item, index) => {
        if (!list.includes(item.url)) {
          if (item.nodes.length > 0) {
            this.pushList(list, item.nodes);
          } else {
            if (item.url) {
              list.push(item.url);
            }
          }
        }
      });
      return list;
    },
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    activeMenu(authPath) {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
<style scoped>
/* .scrollbar-wrapper {
  background: red;
} */
/* ::deep  .el-message-box__wrapper{
  background: red !;
} */
/* .messageIndex {
  z-index: 3000 !important;
} */
</style>
